export default [
    {
        question: "Welk kapsel?",
        answers: [
            {
                photo: require('@/assets/answerPictures/bun.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/bald.jpg'),
            }
        ]
    },
    {
        question: "Karaokebar of concert?",
        answers: [
            {
                photo: require('@/assets/answerPictures/karaoke.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/concert.jpg'),
            }
        ]
    },
    {
        question: 'Doe je aan sport?',
        answers: [
            {
                photo: require('@/assets/answerPictures/nosport.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/sports.jpg'),
            },
        ],
    },
    {
        question: 'Wat is uw burgerlijke stand?',
        answers: [
            {
                photo: require('@/assets/answerPictures/foreveralone.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/happytogether.jpg'),
            },
        ],
    },
    {
        question: "Eet je vlees?",
        answers: [
            {
                photo: require('@/assets/answerPictures/bbq.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/vegeteteraian.jpg'),
            }
        ]
    },
    {
        question: "Auto of trein?",
        answers: [
            {
                photo: require('@/assets/answerPictures/car.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/train.jpg'),
            }
        ]
    },
    {
        question: "Ijsbad of sauna?",
        answers: [
            {
                photo: require('@/assets/answerPictures/icebath.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/sauna.jpg'),
            }
        ]
    },
    {
        question: "Eieren; gooien of opeten?",
        answers: [
            {
                photo: require('@/assets/answerPictures/throwingeggs.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/usingeggs.jpg'),
            }
        ]
    },
    {
        question: "To beer or not to beer?",
        answers: [
            {
                photo: require('@/assets/answerPictures/beer.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/cola.jpg'),
            }
        ]
    },
    {
        question: "Hou je van koeien, of hou je van koeien eten?",
        answers: [
            {
                photo: require('@/assets/answerPictures/lovecow.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/lovetoeatacow.jpg'),
            }
        ]
    },
    {
        question: "Hoe besteed jij je tijd het liefste?",
        answers: [
            {
                photo: require('@/assets/answerPictures/familytime.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/gamingtime.jpg'),
            }
        ]
    },
    {
        question: "Ben jij een harde rijder?",
        answers: [
            {
                photo: require('@/assets/answerPictures/slowcar.png'),
            },
            {
                photo: require('@/assets/answerPictures/fastcar.png'),
            }
        ]
    },
    {
        question: "Mijn goeiste vak is Nederlandsch. Welk woord is juist?",
        answers: [
            {
                photo: require('@/assets/answerPictures/correctspelling.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/wrongspelling.jpg'),
            }
        ]
    },
    {
        question: "Voor of achter de bar?",
        answers: [
            {
                photo: require('@/assets/answerPictures/inthecafe.jpg'),
            },
            {
                photo: require('@/assets/answerPictures/behindthebar.jpg'),
            }
        ]
    },
];
